import ajax, { skk_axios as axios } from "@/common/ajax.js";

// 获取开放填报的年度
export function canRegYear() {
  return ajax.request.get("/api/performance/canRegYear");
}

// 首页能填报的年度
export function regYearEntry() {
  return ajax.request.get("/api/performance/regYearEntry");
}

// 新增业绩(一次性增加很多条)
export const createPer = (data) => {
  return ajax.request({
    url: "/api/performance/create",
    method: "post",
    data,
  });
};

// 新增业绩(一条一条添加)
export const createEach = (data) => {
  return ajax.request({
    url: "/api/project/create",
    method: "post",
    data,
  });
};
// 新增业绩(一条一条添加)
export const editEach = (data) => {
  return ajax.request({
    url: "/api/project/edit",
    method: "post",
    data,
  });
};

/**
 * 查询业绩每一年的列表
 * @param year
 * @param record_id
 * @returns {AxiosPromise}
 */
export const perList = (year, record_id) => {
  return ajax.request({
    url: "/api/performance/getPerByYear",
    method: "post",
    data: {
      year,
      record_id,
    },
  });
};

/**
 * 进入到最终审核阶段
 * @param params
 * @returns {AxiosPromise}
 */
export const submitExamine = (record_id) => {
  return axios({
    url: "/api/performance/submitExamine",
    method: "post",
    data: {
      record_id,
    },
  });
};
/**
 * 删除业绩
 * @param {*} params
 * @returns
 */
export const deleteRow = (params) => {
  return axios({
    url: "/api/performance/delete",
    method: "get",
    params,
  });
};

/**
 * 删除业绩  每一条
 * @param id
 */
export const delEachRow = (id) => {
  return ajax.request({
    url: "/api/project/delete",
    method: "post",
    data: {
      id,
    },
  });
};

/**
 * 删除业绩
 * @param {*} params
 * @returns
 */
export const performance_update = (data) => {
  return ajax.request({
    url: "/api/Performance/update",
    method: "post",
    data,
  });
};

/**
 * 删除业绩
 * @param {*} params
 * @returns
 */
export const isFinish = (params) => {
  return axios({
    url: "/api/project/isFinish",
    method: "get",
    params,
  });
};
